import { ReactNode } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
  Button,
} from "@tellescope/ui";
import { useTranslation } from "react-i18next";

export interface AttachDialogShellProps {
  trigger?: ReactNode;
  title: string;
  description: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCount: number;
  onAttach: () => void;
  onCancel: () => void;
  confirmTrackingId: string;
  children: ReactNode;
}

export const AttachDialogShell = ({
  trigger,
  title,
  description,
  open,
  onOpenChange,
  selectedCount,
  onAttach,
  onCancel,
  confirmTrackingId,
  children,
}: AttachDialogShellProps) => {
  const { t } = useTranslation("inbox");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {!!trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="max-w-2xl max-h-[80vh] flex flex-col" divided>
        <DialogHeader className="pb-2">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {children}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t("Cancel")}
          </Button>
          <Button onClick={onAttach} disabled={selectedCount === 0} data-trackingid={confirmTrackingId}>
            {t("Attach")} {selectedCount > 0 && `(${selectedCount})`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
